import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import { TextField } from 'common/components/forms';
import { zipCodeNormalize } from 'common/helpers/addresses';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { subscribe } from 'redux/forms/actions';

import SubscribeFormSuccess from './SubscribeFormSuccess';
import NameFields from './components/NameFields';
import ZipCode from './components/ZipCode';
import { validateSubmit } from './validators';

class SubscribeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formSumbitted: false,
      error: null
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, props);
    const successFunction = () => {
      this.setState({
        formSumbitted: true
      });
    };
    const failFunction = (error) => {
      let message =
        'Unfortunately there was an error subscribing to to our mailing list.';
      if (error?.response?.data) {
        message += ` ${error.response.data.message}`;
      }
      this.setState({
        error: message
      });
    };
    props.subscribe(data, successFunction, failFunction);
  };

  render() {
    const { props, state } = this;
    const { handleSubmit, hasNameFields, hasZipCode, settings } = props;
    if (!settings.data) {
      return null;
    }
    if (!state.formSumbitted) {
      return (
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <NameFields hasNameFields={hasNameFields} />
          <Field
            name="email"
            component={TextField}
            autocomplete="email"
            label="Email"
            required
          />
          <ZipCode hasZipCode={hasZipCode} />
          <div className="c7-form__button-row">
            <button type="submit" className="c7-button">
              Submit
            </button>
          </div>
          {state.error && (
            <span className="c7-message--error">Error: {state.error}</span>
          )}
        </Form>
      );
    }

    return <SubscribeFormSuccess />;
  }
}

const transformData = (values, ownProps) => {
  const data = {
    email: values.email
  };
  if (ownProps.hasNameFields) {
    data.firstName = values.firstName;
    data.lastName = values.lastName;
  }
  if (ownProps.hasZipCode && values.zipCode) {
    const countryCode = getDefaultCountryCode(ownProps.settings);
    data.countryCode = getDefaultCountryCode(ownProps.settings);
    data.zipCode = zipCodeNormalize(values.zipCode, countryCode);
  }

  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values, ownProps);
  const errors = validateSubmit(data, ownProps);
  return errors;
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

SubscribeForm = reduxForm({
  form: 'SubscribeForm',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(SubscribeForm);

export default connect(mapStateToProps, {
  subscribe
})(SubscribeForm);
